/*
Base compatibility shim for switching from react-rails to vite-rails.
Load heavy globals through the helpers below on the pages that still need them.
*/

import '@vitejs/plugin-react/preamble';
import * as ActionCable from '@rails/actioncable';
import cableSetup from './components/cable.ts';
import React from 'react';
import {
  renderReactRoot,
  unmountReactRoot,
} from './components/renderReactRoot';

window.ActionCable = ActionCable;
cableSetup();

window.React = React;
window.renderReactRoot = renderReactRoot;
window.unmountReactRoot = unmountReactRoot;

const ensureLegacyModule = (cacheKey, loadModule) => {
  window.__legacyViteShimPromises = window.__legacyViteShimPromises || {};

  if (!window.__legacyViteShimPromises[cacheKey]) {
    window.__legacyViteShimPromises[cacheKey] = loadModule();
  }

  return window.__legacyViteShimPromises[cacheKey];
};

const legacyBundleRegistry = {
  dropzone: {
    load: () => import('./react_rails_to_vite_dropzone.js.jsx'),
    resolve: () => window.Dropzone,
  },
  pdfjs: {
    load: () => import('./react_rails_to_vite_pdfjs.js.jsx'),
    resolve: () => window.pdfjsLib,
  },
  signature_pad: {
    load: () => import('./react_rails_to_vite_signature_pad.js.jsx'),
    resolve: () => window.SignaturePad,
  },
  spreadsheet: {
    load: () => import('./react_rails_to_vite_spreadsheet.js.jsx'),
    resolve: () => window.Handsontable,
  },
  swiper: {
    load: () => import('./react_rails_to_vite_swiper.js.jsx'),
    resolve: () => window.Swiper,
  },
};

window.loadLegacyBundle =
  window.loadLegacyBundle ||
  function (bundleName) {
    const bundle = legacyBundleRegistry[bundleName];
    if (bundle == null) {
      return Promise.reject(new Error(`Unknown legacy bundle: ${bundleName}`));
    }

    return ensureLegacyModule(bundleName, bundle.load).then(bundle.resolve);
  };

window.loadLegacyBundles =
  window.loadLegacyBundles ||
  function (bundleNames) {
    return Promise.all(bundleNames.map(window.loadLegacyBundle));
  };

window.withLegacyBundles =
  window.withLegacyBundles ||
  function (bundleNames, callback) {
    return window.loadLegacyBundles(bundleNames).then(callback);
  };
